/**
 * GBG journey-level outcome (retrieval HighLevelResult or SDK meta.journey.highLevelResult).
 * @see public/id-scan/idscan-jcs.d.ts HighLevelResult enum
 */
export function isHighLevelResultPassed(highLevelResult) {
  return highLevelResult?.toUpperCase() === 'PASSED';
}
